import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { hideAssets } from '@api/assets';

import { TAssetVisibilityDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_VISIBILITY_HIDE, ASSETS_LIST, ASSETS_LIST_SHOW_HIDE_FILTER } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutationsAssetVisibilityHide = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleHideAssets,
		isLoading: isLoadingHideAssets,
	} = useMutation<TAssetVisibilityDTO>({
		mutationKey: [ASSET_VISIBILITY_HIDE],
		mutationFn: hideAssets,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetsGroupHideSuccess,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([
				ASSETS_LIST,
				ASSETS_LIST_SHOW_HIDE_FILTER,
			]);
		},
	});

	return {
		handleHideAssets,
		isLoadingHideAssets,
	};
};
